import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { Locale } from 'libs.i18n-core';
import { getApplicableVersion, useProductLocalization, usePreviewComponent } from 'libs.localization.react';
import { Spinner } from 'libs.nucleus';
import { AssetTranslationScreen } from './asset_translation_screen.component';
const baseLocale = Locale.en_US;
export const AssetReviewScreenList = ({ localizationEntry, productVersion, }) => {
    const { locale } = useParams();
    const { localizationEntry: productLocEntry, isLoading: isLoadingProductLocalzation } = useProductLocalization('product_previews.built_in~1_0');
    const isCompareMode = baseLocale !== locale;
    const localizationResources = localizationEntry?.localization_resources;
    const previewOptions = localizationEntry.metadata?.preview;
    const PreviewComponent = usePreviewComponent(previewOptions, productVersion);
    const basePreview = localizationResources?.[baseLocale];
    const localePreview = localizationResources?.[locale];
    const { localization_resources: productLocResources } = productLocEntry;
    const { human_id: humanId } = localizationEntry;
    const applicableVersion = getApplicableVersion(productVersion);
    const versionedHumanId = `${humanId}_r${applicableVersion}`;
    const baseProductMessages = productLocResources?.[baseLocale]?.[versionedHumanId] ||
        productLocResources?.[baseLocale]?.[humanId];
    const localeProductMessages = productLocResources?.[locale]?.[versionedHumanId] ||
        productLocResources?.[locale]?.[humanId];
    const namespaceSortIndex = localizationEntry?.metadata?.localization_resources_sort_index?.namespaces || {};
    const screens = Object.keys(namespaceSortIndex).sort((a, b) => (namespaceSortIndex[a] ?? 0) - (namespaceSortIndex[b] ?? 0));
    let currentIndex = 0;
    return screens.flatMap((key, idx) => {
        const messageSortIndex = localizationEntry?.metadata?.localization_resources_sort_index?.messages?.[key];
        const baseResult = PreviewComponent({
            messages: basePreview?.[key],
            productMessages: baseProductMessages,
            locale: baseLocale,
            sortIndex: messageSortIndex,
        });
        const localeResult = PreviewComponent({
            messages: localePreview?.[key],
            productMessages: localeProductMessages,
            locale: locale,
            sortIndex: messageSortIndex,
        });
        const baseScreens = baseResult || [];
        const localeScreens = localeResult || [];
        const count = Math.max(baseScreens.length, localeScreens.length, 1);
        if (isLoadingProductLocalzation) {
            return [_jsx(Spinner, {}, `loading-${key}`)];
        }
        return Array.from({ length: count }).map((_, i) => {
            const element = (_jsxs("div", { children: [_jsxs("div", { className: 'mb-2', children: [`${currentIndex + 1}. ${baseLocale}`, isCompareMode && ` compared to ${locale}`] }), _jsx(AssetTranslationScreen, { PreviewComponent: PreviewComponent, basePreview: basePreview?.[key], localePreview: localePreview?.[key], baseProductMessages: baseProductMessages, localeProductMessages: localeProductMessages, sortIndex: messageSortIndex, screenIndex: i }), idx === screens.length - 1 && i === count - 1 ? null : _jsx("hr", {})] }, `${key}-${currentIndex}`));
            currentIndex += 1;
            return element;
        });
    });
};
